import { useModalContext } from 'utils/contexts/modal';
import { RenameListFolderModal } from './RenameListFolderModal';
import { DeleteListsModal } from './DeleteListsModal';
import { MoveToListFolderModal } from './MoveToListFolderModal';
import { DeleteListContentsAndFoldersModal } from './DeleteListContentsAndFoldersModal';
import { ListIndexModalState } from '../../types';
import { CreateListFolderModal } from './CreateListFolderModal';

export const ListIndexModals = () => {
  const { modalState } = useModalContext<ListIndexModalState>();

  switch (modalState) {
    case ListIndexModalState.confirmDelete:
      return <DeleteListsModal />;
    case ListIndexModalState.createFolder:
      return <CreateListFolderModal />;
    case ListIndexModalState.moveFolderContents:
      return <MoveToListFolderModal />;
    case ListIndexModalState.renameListFolder:
      return <RenameListFolderModal />;
    case ListIndexModalState.deleteListFolderAndContents:
      return <DeleteListContentsAndFoldersModal />;
    default:
      return null;
  }
};
